import React from 'react'
import { useCurrentTheme } from '../../hooks/useCurrentTheme'
import styles from './CardHelpers.module.scss'
import { suitsMapper } from './CardImage'
import { getContrastColor } from '../../helpers/helpers'
import classNames from 'classnames'

export function CardTextBlock({
	onClick = null,
	cards,
	isSquare = false,
	isAdaptive = false,
	isFullWidth = false,
	preset = null,
	style = {},
	isClickable = true,
}) {
	const theme = useCurrentTheme()
	const currentTheme = preset ?? theme
	const activeColor = currentTheme.cards.suits

	if (!cards) {
		return <></>
	}

	const cardArr = []

	if (cards) {
		const cardStr = cards.toString()
		for (let i = 0; i < cardStr.length - 1; i += 2) {
			const card = cardStr.substring(i, i + 2)
			cardArr.push({ color: activeColor[card[1]], number: card[0], suit: suitsMapper[card[1]] })
		}
	}

	return (
		<div
			onClick={onClick}
			className={classNames(
				styles.cardBackground,
				isSquare ? styles.squareContainer : '',
				isAdaptive ? styles.adaptiveCardContainer : '',
				isFullWidth ? styles.fullWidthContainer : ''
			)}
			style={style}
		>
			{cardArr.map((card, index, array) => (
				<div
					className={classNames(
						styles.cardTextBackground,
						isSquare ? styles.squareCard : '',
						isAdaptive ? styles.adaptiveCard : '',
						isClickable ? '' : styles.cardTextBackground__withoutPointer
					)}
					style={{
						background: card.color,
						width: isFullWidth ? `${100 / array.length}%` : null,
					}}
					key={index}
				>
					<span
						style={{ color: getContrastColor(card.color), width: '100%' }}
						className={[isSquare ? styles.squareCardValue : ''].join(' ')}
					>
						{card.number}
					</span>
				</div>
			))}
		</div>
	)
}
